<template>
  <div class="agreement">
    <div class="title">
      注册和登录即代表您已同意
      <span @click="close"> 《 {{ system.title }}网用户服务协议 》 </span>
    </div>
    <div class="box" v-if="ishide">
      <div class="boxtitle">
        <p>{{ system.title }}网用户服务协议</p>
        <i class="el-icon-close" @click="close"></i>
      </div>
      <div class="con" v-html="system.statement"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'agreement',
  data () {
    return {
      ishide: false
    }
  },
  components: {
  },
  created () {
  },
  computed: {
    system () {
      return this.$store.state.getsystem.system
    }
  },
  methods: {
    close () {
      this.ishide = !this.ishide
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./agreement.scss";
</style>



// WEBPACK FOOTER //
// src/components/login/agreement/agreement.vue